import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ClaudeDesktop } from '../claude-desktop/claude-desktop';

@Component({
  selector: 'app-readme',
  imports: [RouterLink],
  templateUrl: './readme.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './readme.css'
})
export class ReadmeComponent extends ClaudeDesktop {

}
